import React from 'react';
import { Field, getIn } from 'formik';
import { DateInput as DateInputField } from '../../form';

const DateInput = ({
  placeholder,
  onChange,
  readOnly,
  resetValue,
  label,
  disabled,
  ...rest
}) => (
  <Field {...rest}>
    {({ field, form }) => {
      const props = {};
      const error = getIn(form.errors, field.name);
      const touch = getIn(form.touched, field.name);

      const onReset = () => {
        const initialValue = getIn(form.initialValues, field.name);
        form.setFieldTouched(field.name, false);
        form.setFieldValue(field.name, resetValue || initialValue || '');
      };

      const onChangeCustom = (date, e) => {
        form.setFieldValue(field.name, date);
        if (onChange) {
          onChange(date, e);
        }
      };

      const onBlurCustom = () => {
        form.setFieldTouched(field.name, true);
      };

      return (
        <DateInputField
          {...field}
          {...props}
          label={label}
          onChange={onChangeCustom}
          onBlur={onBlurCustom}
          onReset={onReset}
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={disabled}
          error={!readOnly && touch && error}
        />
      );
    }}
  </Field>
);

export default DateInput;
